export default __webpack_public_path__ + "static/hero_desktop-dbeb476b3a0c18be0a21d738cbd7aa69.webp";